import { Routes } from '@front-app/constants/routes';
import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { PhoenixRouteConfig } from '../Model';

export const userRoutes: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string { return i18n.t('page.title.user-profile') as string; },
		},
		path: '/profile',
		name: Routes.CURRENT_USER_PROFILE,
		component: () => import(/* webpackChunkName: "userProfile" */ '@front-app/views/UserProfile.vue'),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(): any {
			return {
				userId: '',
			};
		},
	},
	{
		meta: {
			title(i18n: VueI18n): string { return i18n.t('page.title.user-profile') as string; },
		},
		path: '/profile/:userId',
		name: Routes.USER_PROFILE,
		component: () => import(/* webpackChunkName: "userProfile" */ '@front-app/views/UserProfile.vue'),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				userId: route.params.userId,
			};
		},
	},
	{
		meta: { title(i18n: VueI18n): string { return i18n.t('settings') as string; } },
		path: '/settings',
		name: Routes.USER_SETTINGS,
		component: () => import(/* webpackChunkName: "userProfile" */ '@front-app/views/UserSettings.vue'),
	},
	{
		meta: { title(i18n: VueI18n): string { return i18n.t('user-menu.learning-programs') as string; } },
		path: '/learning',
		name: Routes.USER_LEARNING_PROGRAMS,
		component: () => import(/* webpackChunkName: "userProfile" */ '@front-app/views/UserLearningPrograms.vue'),
	},
];
